import { MenuItem, Typography, MenuItemProps } from '@mui/material';
import { useHasAccess } from '../../payWall/RevenueCatProvider';
import { Link } from 'react-admin';
import { PaidFeatureIcon } from '../pay-wall/PaidFeatureIcon';
import { MembershipType } from '../../payWall/paywall.model';
import { HistoricalPeriod } from '@models/historical-period-map';

export const dateRangeItem = (value: HistoricalPeriod) => (
  <Typography variant='inherit'>
    {value.name}
  </Typography>
);

const membershipFromHistoricalPeriod = (period: HistoricalPeriod): MembershipType => {
  if (period.months <= 12) {
    return 'Free';
  } else if (period.months <= 36) {
    return 'Novice';
  } else {
    return 'Pro';
  }
};

type DateRangeMenuItemProps = MenuItemProps & { period: HistoricalPeriod };

export const DateRangeMenuItem = ({
  period: value,
  ...props
}: DateRangeMenuItemProps) => {
  const [hasNoviceAccess] = useHasAccess('Novice');
  const [hasProAccess] = useHasAccess('Pro');

  const requiredMembership = membershipFromHistoricalPeriod(value);

  const isAvailable =
    (requiredMembership === 'Free') ||
    (requiredMembership === 'Novice' && hasNoviceAccess) ||
    (requiredMembership === 'Pro' && hasProAccess);

  if (!isAvailable) {
    return (
      <MenuItem href component={Link} to='/pricing'>
        <PaidFeatureIcon membership={requiredMembership} />
        {dateRangeItem(value)}
      </MenuItem>
    );
  }

  return (
    <MenuItem {...props}>{dateRangeItem(value)}</MenuItem>
  );
};


